'use strict';

/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 */
module.exports = require('./FlipMove');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-flip-move/lib/index.js
 ** module id = 241
 ** module chunks = 0
 **/